export const MODAL_ID = "company-report-modal";
